import { InboxOutlined } from '@ant-design/icons'
import { Upload } from 'antd'
import * as XLSX from 'xlsx'
import Notification from '@/components/Notification'

const { Dragger } = Upload

const App = ({ uploadFileHandler }) => {

  const onChange = (info) => {
    const file = info.file.originFileObj
    onImportExcel(file)
  }
  const onDrop = (e) => {
    console.log('Dropped files', e.dataTransfer.files)
  }
  const onImportExcel = (file) => {
    // 获取上传的文件对象
    // const { files } = file.target;
    // 通过FileReader对象读取文件
    const fileReader = new FileReader()
    fileReader.onload = (event) => {
      try {
        const { result } = event.target
        // 以二进制流方式读取得到整份excel表格对象
        const workbook = XLSX.read(result, { type: 'binary' })
        let data = [] // 存储获取到的数据
        // 遍历每张工作表进行读取（这里默认只读取第一张表）
        for (const sheet in workbook.Sheets) {
          if (workbook.Sheets.hasOwnProperty(sheet)) {
            // 利用 sheet_to_json 方法将 excel 转成 json 数据
            data = data.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet]))
            break // 如果只取第一张表，就取消注释这行
          }
        }
        uploadFileHandler(data)
      } catch (e) {
        // 这里可以抛出文件类型错误不正确的相关提示
        Notification.Warning('文件类型不正确')
      }
    }
    // 以二进制方式打开文件
    fileReader.readAsBinaryString(file)
  }

  return (
    <Dragger onChange={onChange} onDrop={onDrop}>
      <p className="ant-upload-drag-icon">
        <InboxOutlined />
      </p>
      <p>将文件拖到此处或点击上传</p>
      {/* <p className="ant-upload-text">Click or drag file to this area to upload</p>
      <p className="ant-upload-hint">
        Support for a single or bulk upload. Strictly prohibit from uploading company data or other band files
      </p> */}
    </Dragger>
  )
}
export default App
